import { Flex } from "@similarweb/ui-components/foundations";

import { swSettings } from "app/common/services/swSettings";
import DownloadButtonMenu from "app/components/React/DownloadButtonMenu/DownloadButtonMenu";

import { GROWTH_OVERVIEW_QUERY_KEY } from "../const";
import { useGrowthOverviewContext } from "../context/GrowthOverviewProvider";
import { getGrowthOverviewExcelLink } from "../utils/getGrowthOverviewExcelLink";

interface IGrowthOverviewExportButtonsProps {
    totalCount: number;
}

export const GrowthOverviewExportButtons = ({ totalCount }: IGrowthOverviewExportButtonsProps) => {
    const { granularity, metric, debouncedSearchTerm } = useGrowthOverviewContext();
    const isExcelAllowed = swSettings.current.resources.IsExcelAllowed;
    const excelLink = getGrowthOverviewExcelLink(granularity, metric, debouncedSearchTerm);

    return (
        <Flex
            alignItems="center"
            gap="8px"
        >
            <DownloadButtonMenu
                data-automation={`${GROWTH_OVERVIEW_QUERY_KEY}-download-excel`}
                Excel
                downloadUrl={excelLink}
                excelLocked={!isExcelAllowed}
                totalCount={totalCount}
            />
        </Flex>
    );
};
